import { Product } from './product';

export interface IUpSellResponse {
    products?: Product[];
    token?: string;
}

export interface IUpSellCallbacks {
    onChange?: Function;
    onPurchaseAction?: Function;
    onSkipAction?: Function;
    onProductQuantityAction?: Function;
}


export interface IUpSellQuantityChangeResponse {
    productName: string;
    quantity: number;
    paymentQuantity: number;
}

export enum IUpSellChangeEvent {
    QuantityChange = 'QuantityChange',
    SelectChange = 'SelectChange'
}

export interface IUpSellEvent {
    prodType: string;
    evType: IUpSellChangeEvent;
    product: Product;
    quantity?: number;
    prodAmount: number;
}

export interface IUpSellRenderModel {
    products: Product[];
    currency: string;
    callback: Function;
    isOneProduct: boolean;
}

export interface IUpSellGenerateViewModel {
    product: Product;
    currency: string;
    callback: Function;
    isOneProduct: boolean;
}


export interface IUpSellOrderItem {
    paymentType: string;
    productName: string;
    amount: number;
    currency: string;
    tax: number | null;
    discountId: null;
    quantity: number;
    subscriptionPlanId: string | null;
    dynamicPlanInterval: string | null;
    couponId: null;
    trialDays: null;
}

export interface IUpSellSubmissionModel {
    dfFormId: string;
    hsFormId: string;
    hscontext: string;
    mode: string;
    url: string;
    invoiceFooter: string;
    paymentMethod: {
        type: string;
        token: string | null;
        paymentMethodId: string | null;
        businessEmail: string | null;
        accountId: string | null;
    };
    params: {
        email: string;
        firstname: string;
        lastname: string;
        mobilephone: string;
        address: string;
        city: string;
        zip: string;
        state: string;
        country: string;
    };
    result: {
        orderId: string;
        upsell: {
            products: [];
            token: string;
        }
    };
    files: [];
    orderItems: IUpSellOrderItem[];
    orderId: string;
    upsellToken: string;
    recaptchaScore?: string;
    recaptchaSessionId?: string;
    recaptchaTokenV2?: string;
    recaptchaTokenV3?: string;
}
